var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNubePequeaDerechaAzulBirdybacker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 323,
    height: 156,
    viewBox: "0 0 323 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M338 155.992L72.512 155.156C55.4225 155.457 41.4085 141.694 41.4085 124.607C41.4085 107.731 55.0908 94.0507 71.9693 94.0507H157.055C170.941 94.0507 182.196 82.7975 182.196 68.9138C182.196 55.03 170.941 43.7768 157.055 43.7768H21.8916C9.79996 43.7768 0 33.9783 0 21.8884C0 9.79852 9.79996 0 21.8916 0H338V156V155.992Z",
    fill: "#B5EAD7",
    fillOpacity: 0.31
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNubePequeaDerechaAzulBirdybacker);
export default __webpack_public_path__ + "static/media/nube-pequeña-derecha-azul-birdybacker.c4b3dba983593f1f8938cc60d2f6f847.svg";
export { ForwardRef as ReactComponent };